import type { BreakoutUser } from '@breakoutlearning/firebase-repository/models/BreakoutUser'
import { createContext } from 'react'

type UserContextStore = {
  user: BreakoutUser
}

export const UserContext = createContext<UserContextStore | null>(null)
